export const tenantDefaultKeys = {
  all: ['tenant-defaults'] as const,
  detail: (): readonly string[] => [...tenantDefaultKeys.all, 'detail'] as const,
};
